import { DidomiProvider } from './didomi.provider';

export const didomiFactory = (didomiProvider: DidomiProvider): (() => void) => {
  return () => didomiProvider.load();
};
